export const accessLocalStorage = (type) => {
    if (localStorage.getItem(type) === null) {
        //console.log(`${type} not found in LocalStorage`)
        return null;
        // throw new Error(`${type} not found`);
    }
    return localStorage.getItem(type)
};